import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const Panel = ({ title , icon ='info' , className , children  })=>{
    if (!title || !children) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames([
            'panel',
            className
        ])
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "panel__header"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        className: "panel__icon",
        name: icon
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1",
        className: "panel__title"
    }, title)), /*#__PURE__*/ React__default.createElement("div", {
        className: "panel__content"
    }, children));
};

export { Panel, Panel as default };
//# sourceMappingURL=Panel.js.map
